<mat-form-field appearance="fill" class="language-select"> 
    <mat-label>{{'communication language' | translate:['tmc-yard.entity.transport.messaging.communicationLanguage', translationService.language]}}</mat-label>
    <mat-select [formControl]="formControl" [required]="required">
        <mat-option *ngFor="let language of availableLanguages" [value]="language.key">
            {{ language.name | translate:['common.enum.language.' + language.key, translationService.language] }}
        </mat-option>
    </mat-select>
</mat-form-field>
